
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1xupv_5lrnc_97",
  "wizard": "awsui_wizard_1xupv_5lrnc_132",
  "refresh": "awsui_refresh_1xupv_5lrnc_132",
  "small-container": "awsui_small-container_1xupv_5lrnc_139",
  "navigation": "awsui_navigation_1xupv_5lrnc_148",
  "number": "awsui_number_1xupv_5lrnc_182",
  "circle": "awsui_circle_1xupv_5lrnc_198",
  "title": "awsui_title_1xupv_5lrnc_209",
  "active": "awsui_active_1xupv_5lrnc_240",
  "disabled": "awsui_disabled_1xupv_5lrnc_251",
  "enabled": "awsui_enabled_1xupv_5lrnc_261",
  "form": "awsui_form_1xupv_5lrnc_305",
  "form-header": "awsui_form-header_1xupv_5lrnc_310",
  "form-header-content": "awsui_form-header-content_1xupv_5lrnc_326",
  "form-component": "awsui_form-component_1xupv_5lrnc_330",
  "hidden": "awsui_hidden_1xupv_5lrnc_344",
  "collapsed-steps": "awsui_collapsed-steps_1xupv_5lrnc_348",
  "collapsed-steps-hidden": "awsui_collapsed-steps-hidden_1xupv_5lrnc_353",
  "form-header-component-wrapper": "awsui_form-header-component-wrapper_1xupv_5lrnc_357",
  "form-header-component": "awsui_form-header-component_1xupv_5lrnc_357",
  "navigation-link": "awsui_navigation-link_1xupv_5lrnc_373",
  "navigation-link-item": "awsui_navigation-link-item_1xupv_5lrnc_374",
  "navigation-link-label": "awsui_navigation-link-label_1xupv_5lrnc_375",
  "navigation-link-active": "awsui_navigation-link-active_1xupv_5lrnc_379",
  "navigation-link-disabled": "awsui_navigation-link-disabled_1xupv_5lrnc_384",
  "cancel-button": "awsui_cancel-button_1xupv_5lrnc_388",
  "previous-button": "awsui_previous-button_1xupv_5lrnc_389",
  "primary-button": "awsui_primary-button_1xupv_5lrnc_390",
  "skip-to-button": "awsui_skip-to-button_1xupv_5lrnc_391",
  "action-buttons": "awsui_action-buttons_1xupv_5lrnc_395"
};
  